import type { SVGAttributes } from "react";

import { css, tokenSchema } from "@keystar/ui/style";
import { Heading } from "@keystar/ui/typography";
import { Link, useRouter } from "@keystone-6/core/admin-ui/router";

// Mirrors Keystone's DefaultLogo, except on the sign-in page the logo is
// rendered as plain text instead of a link so unauthenticated visitors have
// nothing to click through to the admin UI.
const LogoMark = (props: SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 118 76" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M118.184 38.184 87 0H70l31.367 38.367-31.184 38.184L87 76.368l31.184-38.184Z"
      fill={tokenSchema.color.background.accentEmphasis}
    />
    <path
      d="M8 38.184 39.184 0h17L24.816 38.367 56 76.552l-16.816-.183L8 38.184Z"
      fill={tokenSchema.color.foreground.neutral}
    />
    <path d="M0 0h13v76H0V0Z" fill={tokenSchema.color.foreground.neutral} />
  </svg>
);

const logoStyles = css({
  alignItems: "center",
  color: tokenSchema.color.alias.foregroundIdle,
  display: "flex",
  gap: tokenSchema.size.space.regular,
  outline: 0,
  textDecoration: "underline",
  textDecorationColor: "transparent",
  textDecorationThickness: tokenSchema.size.border.regular,
  textUnderlineOffset: tokenSchema.size.border.medium,
  "&:hover, &:focus-visible": {
    color: tokenSchema.color.alias.foregroundHovered,
    textDecorationColor: "currentColor"
  },
  "&:focus-visible": {
    textDecorationStyle: "double"
  }
});

export function CustomLogo() {
  const { pathname } = useRouter();
  const content = (
    <>
      <LogoMark className={css({ width: tokenSchema.size.element.small })} />
      <span>Keystone</span>
    </>
  );

  return (
    <Heading elementType="div" size="small" UNSAFE_className={css({ lineHeight: 1 })}>
      {pathname === "/signin" ? (
        <div className={logoStyles}>{content}</div>
      ) : (
        <Link href="/" className={logoStyles}>
          {content}
        </Link>
      )}
    </Heading>
  );
}
